import { nToPx, rowCenterClass, themeVars, toBorder } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const containerClass = style([
  rowCenterClass,
  {
    gap: 0,
  },
]);

export const itemClass = style({
  fontSize: themeVars.font.size.textLg,
  padding: nToPx(0, themeVars.space.x4),
  borderRight: toBorder(themeVars.colors.neutrals.grey50),
  margin: 0,
  maxHeight: 'fit-content',
});

export const firstItemClass = style([
  itemClass,
  {
    paddingLeft: 0,
  },
]);

export const lastItemClass = style([
  itemClass,
  {
    borderRight: 'none',
    paddingRight: 0,
  },
]);
